import { experimentsRegistry } from './experiments.registry';

/** The unit an experiment randomises on. `userID` is the customer and
 *  `personID` the person (MVX-371 U5): both are user units, resolved on the
 *  client once the provider's user carries that id. */
export type ExperimentUnit = 'stableID' | 'userID' | 'personID';

/** The user units: the ids `identifyCustomer` / `identifyPerson` put on the
 *  provider's user. */
export type UserUnit = Exclude<ExperimentUnit, 'stableID'>;

const entries = experimentsRegistry as Record<
  string,
  { unit?: ExperimentUnit }
>;

/** The Statsig unit an experiment randomises on; unknown/unset → 'stableID'. */
export const experimentUnit = (key: string): ExperimentUnit =>
  entries[key]?.unit ?? 'stableID';

/** Keys that randomise on `unit`. */
export const experimentKeysForUnit = (unit: UserUnit): string[] =>
  Object.keys(entries).filter((k) => entries[k].unit === unit);

/** Every user-unit key (customer or person): re-evaluated on the client once
 *  the provider's user carries the unit's id. */
export const userUnitExperimentKeys = (): string[] => [
  ...experimentKeysForUnit('userID'),
  ...experimentKeysForUnit('personID'),
];
